
import React from 'react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';

const Privacy = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-4">
          <h1 className="text-4xl font-bold text-gray-900 mb-8">Privacy Policy</h1>
          
          <div className="prose prose-lg max-w-none">
            <p className="text-gray-600 mb-6">Last updated: January 2025</p>
            
            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">1. Information We Collect</h2>
            <p className="text-gray-700 mb-4">
              We collect information you provide directly to us, such as when you:
            </p>
            <ul className="list-disc pl-6 text-gray-700 mb-4">
              <li>Create an account or enter a lottery draw</li>
              <li>Contact us for customer support</li>
              <li>Subscribe to our newsletter or marketing communications</li>
              <li>Participate in surveys or promotional activities</li>
            </ul>
            <p className="text-gray-700 mb-4">
              This information may include your name, email address, phone number, date of birth, 
              and payment information.
            </p>
            
            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">2. How We Use Your Information</h2>
            <p className="text-gray-700 mb-4">
              We use the information we collect to:
            </p>
            <ul className="list-disc pl-6 text-gray-700 mb-4">
              <li>Process your lottery entries and prize payments</li>
              <li>Verify your identity and age (18+ requirement)</li>
              <li>Send you important updates about draws and results</li>
              <li>Provide customer support and respond to your inquiries</li>
              <li>Comply with legal and regulatory requirements</li>
              <li>Prevent fraud and ensure fair play</li>
            </ul>
            
            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">3. Form Submission Processing</h2>
            <div className="bg-blue-50 p-6 rounded-lg mb-6">
              <p className="text-gray-700 font-medium">
                Important: Form submissions on our website are sent to a secure Telegram bot for 
                processing. This allows us to quickly respond to your inquiries and process your 
                lottery entries efficiently. Your information is encrypted during transmission 
                and stored securely.
              </p>
            </div>
            
            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">4. Information Sharing</h2>
            <p className="text-gray-700 mb-4">
              We do not sell, trade, or otherwise transfer your personal information to third parties, 
              except in the following circumstances:
            </p>
            <ul className="list-disc pl-6 text-gray-700 mb-4">
              <li>With your explicit consent</li>
              <li>To comply with legal obligations or court orders</li>
              <li>To payment processors for prize payments (encrypted and secure)</li>
              <li>To prevent fraud or protect our legal rights</li>
            </ul>
            
            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">5. Data Security</h2>
            <p className="text-gray-700 mb-4">
              We implement appropriate security measures to protect your personal information against 
              unauthorized access, alteration, disclosure, or destruction. This includes:
            </p>
            <ul className="list-disc pl-6 text-gray-700 mb-4">
              <li>SSL encryption for all data transmission</li>
              <li>Secure server infrastructure with regular security updates</li>
              <li>Limited access to personal information on a need-to-know basis</li>
              <li>Regular security audits and monitoring</li>
            </ul>
            
            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">6. Your Rights Under Australian Privacy Laws</h2>
            <p className="text-gray-700 mb-4">
              Under the Australian Privacy Principles (APP), you have the right to:
            </p>
            <ul className="list-disc pl-6 text-gray-700 mb-4">
              <li>Access your personal information</li>
              <li>Correct inaccurate or incomplete information</li>
              <li>Request deletion of your information (subject to legal requirements)</li>
              <li>Opt out of marketing communications</li>
              <li>Lodge a complaint with the Office of the Australian Information Commissioner</li>
            </ul>
            
            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">7. Cookies and Tracking</h2>
            <p className="text-gray-700 mb-4">
              We use cookies and similar technologies to improve your experience on our website. 
              You can control cookie settings through our cookie banner or your browser settings. 
              For more information, please see our <a href="/cookies" className="text-yellow-600 underline">Cookie Policy</a>.
            </p>
            
            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">8. Data Retention</h2>
            <p className="text-gray-700 mb-4">
              We retain your personal information for as long as necessary to fulfill the purposes 
              outlined in this privacy policy, unless a longer retention period is required by law. 
              Lottery entry records are kept for 7 years as required by Australian gambling regulations.
            </p>
            
            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">9. Contact Us</h2>
            <p className="text-gray-700 mb-4">
              If you have any questions about this Privacy Policy or our data practices, please contact us at:
            </p>
            <ul className="list-none text-gray-700 mb-4">
              <li>Email: privacy@goldenticketlucky.com</li>
              <li>Phone: +61359294105</li>
              <li>Privacy Officer: 24 Balmoral Ave, Springvale VIC 3171</li>
            </ul>
            
            <div className="bg-yellow-50 p-6 rounded-lg mt-8">
              <p className="text-gray-700 font-medium">
                This privacy policy complies with the Australian Privacy Act 1988 and the 
                Australian Privacy Principles. We are committed to protecting your privacy 
                and handling your personal information responsibly.
              </p>
            </div>
          </div>
        </div>
      </section>
      
      <Footer />
    </div>
  );
};

export default Privacy;
